// This file is generated.
export var version = '1.45.0';
//# sourceMappingURL=version.js.map